module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cortex"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.startTest
    }
  }, [_vm._v("Start test")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.stopTest
    }
  }, [_vm._v("Stop test")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee2348b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExperimentCortex.vue
// module id = 333
// module chunks = 1